import React from 'react'
import { Alert, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { downloadSampleTemplate } from '../sample_csv/sampleTemplates'

/**
 * Shared presentational helpers used by every per-language article file.
 * Definitions are kept here so each language file imports them rather than
 * redefining them.
 */

export const TemplateBtn = ({ type, children }) => (
  <Button variant="outline-success" size="sm" className="me-2 mb-2"
    onClick={() => downloadSampleTemplate(type)}>
    <span className="me-1">⬇</span>{children}
  </Button>
)

export const Tip = ({ children }) => (
  <Alert variant="success" className="py-2 my-3" style={{ fontSize: '0.9rem' }}>
    <strong>💡 Tip:</strong> {children}
  </Alert>
)

export const Warn = ({ children }) => (
  <Alert variant="warning" className="py-2 my-3" style={{ fontSize: '0.9rem' }}>
    <strong>⚠️ Watch out:</strong> {children}
  </Alert>
)

export const Code = ({ children }) => (
  <code style={{ background: 'var(--color-neutral-100)', padding: '1px 5px', borderRadius: 4 }}>{children}</code>
)

export const ArticleLink = ({ to, children }) => (
  <Link to={`/documentation?a=${to}`} style={{ color: 'var(--color-primary-dark)', fontWeight: 600 }}>{children}</Link>
)

export const Ext = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer"
    style={{ color: 'var(--color-primary-dark)', fontWeight: 600, textDecoration: 'underline' }}>
    {children || href}
  </a>
)
